'use client';

import classNames from 'classnames';
import { TitleSlug } from '@sapientpro/sapientpro-data-models';
import Link from 'next/link';
import SvgWithCurrentColorChange from '../SvgWithCurrentColorChange';
import styles from './DevelopmentServicesCard.module.scss';

type DevelopmentServicesCardProps = {
  icon: string,
  title: string,
  description: string,
  service: TitleSlug | null,
  subService?: TitleSlug | null,
  titleClassName?: string,
};

const DevelopmentServicesCard = ({
  icon, title, description, service, subService, titleClassName,
}: DevelopmentServicesCardProps) => {
  const isLink = !!(service || subService);
  const WrapperElement = isLink ? Link : 'div';

  return (
    <WrapperElement
      className={styles.developmentServicesCard}
      {...(isLink ? { href: `/${service?.slug || subService?.slug}` } : { href: '/' })}
    >
      <div className={styles.developmentServicesCard__main}>
        <div className={styles.developmentServicesCard__mainIcon}>
          <SvgWithCurrentColorChange
            icon={icon}
            className={styles.developmentServicesCard__mainImage}
          />
        </div>
        <div className={styles.developmentServicesCard__mainContent}>
          <p className={classNames(styles.developmentServicesCard__mainContentTitle, 'header3', titleClassName, {
            [styles.developmentServicesCard__mainContentTitle_link]: isLink,
          })}
          >
            {title}
          </p>
          <p className={classNames(styles.developmentServicesCard__mainContentDescription, 'bodyLarge')}>{description}</p>
        </div>
      </div>
    </WrapperElement>
  );
};

export default DevelopmentServicesCard;
